
const usDollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export const formatMoney = (amt: number | string | undefined) => {
  if(!amt && amt !== 0) return;
  let num = parseFloat(amt+'');
  if(isNaN(num)) return;
  return usDollarFormat.format(num);
}